import { EXTENDED_DESCRIPTION_DEFAULT } from 'shared/constants';
import {
  BrandContact,
  CustomerForm,
  ExpenseForm,
  OrderNoteForm,
  PdfInfo,
  ProductForm,
  TCustomProductForm,
} from 'shared/types';
import { v4 as uuid } from 'uuid';

export const defaultBrandContact: BrandContact = {
  uniqueId: '',
  name: '',
  address1: '',
  address2: '',
  phone: '',
  fax: '',
  contact: '',
};

export const defaultPdfInfo: PdfInfo = {
  rfqNumber: '',
  billToName: '',
  billToAddressLine1: '',
  billToAddressLine2: '',
  billToPhone: '',
  shipToName: '',
  shipToAddressLine1: '',
  shipToAddressLine2: '',
  sameAsShipTo: '',
  productPrefix: '',
  delivery: '',
  quoteTerms: 'Standard Terms and Conditions Apply',
  paymentTerms: 'NET 30',
  freightTerms: 'F.O.B. Shipping Point',
  modifiedQuoteNumber: '',
  quotedBy: '',
  quotedByEmail: '',
  quotedByPhoneNumber: '',
  salesRep: '',
  salesRepEmail: '',
  salesRepPhoneNumber: '',
  quoteNotes: '',
  requestedBy: '',
  products: [],
  expenses: [],
  brandContact: defaultBrandContact,
};

export const defaultProduct: () => ProductForm = () => ({
  isNew: false,
  noType: false,
  recalculate: false,
  newVendor: false,
  outOfScope: false,
  editRevisedPrice: false,
  name: '',
  itemDescriptionAdj: '',
  itemId: '',
  quantity: '',
  productType: '',
  vendorName: '',
  vendorId: '',
  lastCostPaid: '',
  marginAtList: 0,
  marginPercentileEighty: 0,
  listPrice: 0,
  concatenatedItem: '',
  isCustomerVendorContracted: false,
  salesRepAdjustedMargin: 0,
  productGuid: uuid(),
  calculationId: '',
  quantityBreakFlag: false,
  extendedDesc: EXTENDED_DESCRIPTION_DEFAULT,
  costEffectiveDate: '',
  listPriceEffectiveDate: '',
  unitOfMeasure: '',
  MROvsCapital: '',
  factorSheetName: '',
  exchangerate: '',
  freightadder: '',
  currencytype: '',
  customerProductNumber: '',
});

export const defaultCustomProduct: TCustomProductForm = {
  customProductName: '',
  customProductPrice: '',
  customProductQuantity: '',
};

export const defaultExpense: ExpenseForm = {
  price: 0,
  quantity: '',
  type: '',
  extendedPrice: 0,
  itemized: true,
};

export const defaultOrderNote: OrderNoteForm = {
  note: '',
  createdBy: '',
  creationDate: '',
};

export const defaultCustomer: CustomerForm = {
  isNew: false,
  emptyType: false,
  isExcluded: false,
  name: '',
  customerNumber: '',
  customerType: '',
  competition: '',
  corpNameCustomerName: '',
  customerNumberAdjusted: '',
  customerShipTo: null,
  companyId: '',
};
